import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'toDouble',
    pure: false
})
export class ToDoublePipe implements PipeTransform {

    transform(value: any): any {
        if(value=='')
            return '';

        if(!!value?.length && value?.indexOf(',') > -1)
            value = value.replace(/\./gi,'').replace(',','.');
    
        return value; 
    }
}